export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./by-phone.vue?vue&type=template&id=23517c0a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-phone.vue?vue&type=template&id=23517c0a
// module id = GYcH
// module chunks = 0